import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RyderButton from '../RyderButton';
import RyderSelect from '../RyderSelect';
import RyderInput from '../RyderInput';
import Spinner from '../Spinner';
import axios from 'axios';
import moment from 'moment';
import {validateEmail} from '../../utils/helper';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import {
  ContactContainer,
} from './styledComponents';

/**
 * ContactForm Component documentation
 * @property       {object} invoice Object to store data of invoice
 *
 */

class ContactForm extends Component {
  state = {
    showForm: false,
    errorData: false,
    showSpinner: false,
    alertData: {
      showAlert: false,
      alertMessage: '',
      alertIcon: 'success',
      alertTitle: 'Success...',
    },
    contactData: {
      reasonType: '',
      reasonText: '',
      emailAddress: '',
    },
   };

  componentDidMount() {
    this.setState({
      showForm: false,
      errorData: false,
      showSpinner: false,
      alertData: {
        showAlert: false,
        alertMessage: '',
        alertIcon: 'success',
        alertTitle: 'Success...',
      },
      contactData: {
        reasonType: '',
        reasonText: '',
        emailAddress: '',
      },
     });
  }
  handleContactUsClick = (ev) => {
    ev.preventDefault();
    this.setState({ showForm: true });
  };
  validateError = () => {
    const {
      contactData: {
        emailAddress
      },
    } = this.state;
    if (emailAddress && !validateEmail(emailAddress)) {
      this.setState({
        errorData: true,
      });
    } else {
      this.setState({
        errorData: false,
      });
    }
  };
  setContactData = (text, name) => {
    const {
      contactData
    } = this.state;
    contactData[name] = text;
    this.setState({ contactData });
    this.validateError();
  };
  handleSubmit = (ev) => {
    ev.preventDefault();
    this.validateError();
    const {
      errorData,
      contactData: {
        reasonType,
        reasonText,
        emailAddress,
      },
    } = this.state;
    const {
      invoice: {
        metadata: {
          invoiceNumber,
        }
      },
    } = this.props;
    if(!errorData) {
      this.setState({ showSpinner: true });
      let timestamp = moment().format('YYYY-MM-DD[T]HH:mm:ss');
      axios.post('/send-mail', { invoiceNumber, reasonType, replyTo: emailAddress.trim(), reasonText, timestamp })
            .then((result) => {
              if(result.status === 200) {
                this.setState({
                  showForm: false,
                  errorData: false,
                  showSpinner: false,
                  alertData: {
                    showAlert: true,
                    alertMessage: 'Thank you for your submission.',
                    alertIcon: 'success',
                    alertTitle: 'Success...',
                  },
                  contactData: {
                    reasonType: '',
                    reasonText: '',
                    emailAddress: '',
                  },
                });
              } else {
                console.error('Email was not sent.', result.message);
                this.setState({
                  showSpinner: false,
                  alertData: {
                    showAlert: true,
                    alertIcon: 'error',
                    alertMessage: 'An Error has ocurred.',
                    alertTitle: 'Oops...',
                  },
                });
              }
            });
    }
  };
  getErrorText = (field) => {
    const {
      contactData: {
        emailAddress
      },
    } = this.state;
    if(emailAddress && field === 'emailAddress')
      return !validateEmail(emailAddress) ? 'Please, enter a valid Email address' : '';
    else
      return '';
  };
  hideAlert = () => {
    const {
      alertData,
    } = this.state;
    this.setState({
      alertData: {
        ...alertData,
        showAlert: false,
      }
    });
  };
  render() {
    const {
      showForm,
      errorData,
      showSpinner,
      alertData: {
        showAlert,
        alertMessage,
        alertIcon,
        alertTitle,
      },
      contactData: {
        reasonType,
        reasonText,
        emailAddress,
      },
    } = this.state;
    const {
      invoice: {
        metadata: {
          invoiceNumber,
        }
      },
    } = this.props;
    return (
      <ContactContainer onSubmit={this.handleSubmit}>
        {
          !showForm ?
          [
            <p key={'paragraph-1'}>Have a question or concern regarding this invoice?</p>,
            <RyderButton
              key={'contact-us'}
              onClick={this.handleContactUsClick}
            >
              Contact Us
            </RyderButton>
          ] :
          [
            <p key={'paragraph-2'}>{`Use the form below to tell us about your issue with invoice #${invoiceNumber}`}</p>,
            <RyderSelect
              key={'reasonType'}
              name={'reasonType'}
              onChange={this.setContactData}
              value={reasonType}
              required
            >
              <option value="">Select Reason</option>
              <option value="Dispute">Dispute</option>
              <option value="Incorrect amount">Incorrect amount</option>
              <option value="Other issue">Other issue</option>
            </RyderSelect>,
            <RyderInput
              key={'emailAddress'}
              label={'Email address'}
              name={'emailAddress'}
              type={'text'}
              required
              value={emailAddress}
              onChange={this.setContactData}
              errorText={errorData ? this.getErrorText('emailAddress') : ''}
              className="label-top"
            />,
            <RyderInput
              label={'Your message'}
              key={'reasonText'}
              onChange={this.setContactData}
              required
              name={'reasonText'}
              value={reasonText}
              errorText={errorData ? this.getErrorText('reasonText') : ''}
              className="label-top"
              multiline
              rows="10"
              maxLength="500"
            />,
            <RyderButton key={'submit'}>Submit</RyderButton>
          ]
        }
        <SweetAlert
          title={alertTitle}
          show={showAlert}
          type={alertIcon}
          text={alertMessage}
          onConfirm={this.hideAlert}
        />
        { showSpinner && <Spinner /> }
      </ContactContainer>
    );
  }
}

ContactForm.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js